import { setAppReady, setSurvey, setLang, getNext, setUserId } from './appActions';
import { getSurvey, exists } from '../api.js';
import qs from 'qs';

// Cint entry links carry the respondent's RID under whichever name the project was set up with.
const ID_PARAMS = ['id', 'ID', 'rid', 'RID'];

export const appStart = (history, location, cookies) => {
  const fetchSurvey = (sID, lang, userID, attempt = 0) => {
    return async (dispatch) => {
      try {
        const resp = await getSurvey(sID, userID);
        const data = resp.data.data;
        // A screened-out respondent who reloads must not get a second go at the screener.
        if (data.terminated) {
          history.push('/thanks');
          return;
        }

        dispatch(setSurvey(data));
        dispatch(setLang(data.lang, lang || data.lang));

        if (data.css) {
          const useCss = data.css.replace('.css', '');
          const head = document.head;
          ['main', 'modules', 'chat'].forEach((name) => {
            exists(`/styles/${useCss}/${name}.css`).then((res) => {
              if (res.status) {
                const link = document.createElement('link');
                link.type = 'text/css';
                link.rel = 'stylesheet';
                link.href = res.url;
                head.appendChild(link);
              }
            });
          });
        }

        await dispatch(getNext(-1, true));
        dispatch(setAppReady(true));
      } catch (err) {
        if (attempt < 10) {
          setTimeout(() => {
            dispatch(fetchSurvey(sID, lang, userID, attempt + 1));
          }, 500);
        } else {
          history.push('/404');
        }
      }
    };
  };

  return async (dispatch, getCurrentState) => {
    let p = location.pathname.replace(/^\//, '');
    if (p === '') p = 'info';
    if (p === '404') return null;

    const qstr = qs.parse(location.search, { ignoreQueryPrefix: true });
    const id = ID_PARAMS.map((key) => qstr[key]).find(Boolean);

    let userID = getCurrentState().app.userid;
    if (id) {
      dispatch(setUserId(id));
      userID = id;
    }

    dispatch(fetchSurvey(p, qstr.lang, userID));
  };
};
